<template>
  <div>
    <div class="content">
      <div class="contBox">
        <div class="headBox" :style="'width:' + contwidth + 'px;'">
          <div class="box w50"></div>
          <div class="box w10">序号</div>
          <div class="box w10">订单编号</div>
          <div class="box w10">人脸图片</div>
          <div class="box w10">领取人员</div>
        </div>
        <div class="cont" ref="container">
          <div class="boxs">
            <div class="box w50">
              <div class="kuang dis-cent">-</div>
            </div>
            <div class="box w10">123123</div>
            <div class="box w10">订单编号</div>
            <div class="box w10">
              <div class="img">
                <img src="https://img0.baidu.com/it/u=2317612037,2363737113&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500"
                  alt="">
              </div>
            </div>
            <div class="box w10">测试</div>
          </div>
          <div class="cpList">
            <div class="w50"></div>
            <div class="liCont">
              <div class="liBox">
                <div class="liBoxHead">
                  <div class="box w130 dis-cent">产品</div>
                  <div class="box w90 dis-cent">数量</div>
                  <div class="box w90 dis-cent">单价</div>
                </div>
                <div class="liBoxConts">
                  <div class="liBoxCont">
                    <div class="box w130 dis-cent">
                      <div class="img">
                        <img
                          src="https://img0.baidu.com/it/u=2317612037,2363737113&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500"
                          alt="">
                      </div>
                    </div>
                    <div class="box w90 dis-cent">数量</div>
                    <div class="box w90 dis-cent">单价</div>
                  </div>
                </div>
              </div>
              <div class="liBox">
                <div class="liBoxHead">
                  <div class="box w130 dis-cent">产品</div>
                  <div class="box w90 dis-cent">数量</div>
                  <div class="box w90 dis-cent">单价</div>
                </div>
                <div class="liBoxConts">
                  <div class="liBoxCont">
                    <div class="box w130 dis-cent">
                      <div class="img">
                        <img
                          src="https://img0.baidu.com/it/u=2317612037,2363737113&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500"
                          alt="">
                      </div>
                    </div>
                    <div class="box w90 dis-cent">数量</div>
                    <div class="box w90 dis-cent">单价</div>
                  </div>
                </div>
              </div>
              <div class="liBox">
                <div class="liBoxHead">
                  <div class="box w130 dis-cent">产品</div>
                  <div class="box w90 dis-cent">数量</div>
                  <div class="box w90 dis-cent">单价</div>
                </div>
                <div class="liBoxConts">
                  <div class="liBoxCont">
                    <div class="box w130 dis-cent">
                      <div class="img">
                        <img
                          src="https://img0.baidu.com/it/u=2317612037,2363737113&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500"
                          alt="">
                      </div>
                    </div>
                    <div class="box w90 dis-cent">数量</div>
                    <div class="box w90 dis-cent">单价</div>
                  </div>
                </div>
              </div>
              <div class="liBox">
                <div class="liBoxHead">
                  <div class="box w130 dis-cent">产品</div>
                  <div class="box w90 dis-cent">数量</div>
                  <div class="box w90 dis-cent">单价</div>
                </div>
                <div class="liBoxConts">
                  <div class="liBoxCont">
                    <div class="box w130 dis-cent">
                      <div class="img">
                        <img
                          src="https://img0.baidu.com/it/u=2317612037,2363737113&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500"
                          alt="">
                      </div>
                    </div>
                    <div class="box w90 dis-cent">数量</div>
                    <div class="box w90 dis-cent">单价</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      mapList: [],
      fList: [],
      contwidth: 0,
    };
  },

  mounted() {
    this.getContainerWidth();
  },
  methods: {
    getContainerWidth() {
      const el = this.$refs.container;
      if (el) {
        this.contwidth = el.getBoundingClientRect().width;
      }
    }
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: auto;
  padding: 20px;

  .contBox {
    overflow: auto;
    border: 1px solid #000;

    .headBox {
      height: 60px;
      background-color: whitesmoke;
      overflow: hidden;
      border-bottom: 1px solid #000;
      display: inline-flex;
      min-width: max-content;
      width: 100%;

      .box {
        flex-shrink: 0;
        height: 100%;
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 16px;
        padding: 0 15px;
        box-sizing: border-box;
        border-right: 1px solid #ebebeb;
      }

      .box:last-child {
        border-right: none;
      }
    }

    .cont {
      background-color: #fff;
      // overflow: hidden;
      // display: inline-flex;
      min-width: max-content;

      .boxs {
        height: 100px;
        overflow: hidden;
        border-top: 1px solid #ebebeb;

        .box {
          border-right: 1px solid #ebebeb;
          float: left;
          height: 100%;
          display: flex;
          align-items: center;
          font-size: 15px;
          padding: 0 15px;
          box-sizing: border-box;

          .kuang {
            width: 20px;
            height: 20px;
            border: 1px solid #ebebeb;
            padding-bottom: 2px;
            box-sizing: border-box;
            background-color: #fff;
            color: #999;
            border-radius: 3px;
            cursor: pointer;
          }

          .img {
            height: 70px;
            border-radius: 5px;
            overflow: hidden;

            img {
              width: auto;
              height: 100%;
            }
          }
        }

        .box:last-child {
          border-right: none;
        }
      }

      .cpList {
        border-top: 1px solid #ebebeb;
        display: flex;

        .w50 {
          border-right: 1px solid #ebebeb;
        }

        .liCont {
          padding: 15px;
          box-sizing: border-box;
          width: calc(100% - 51px);
          overflow: hidden;

          .liBox {
            border: 1px solid #000;
            overflow: hidden;
            float: left;
            margin-right: 15px;
            margin-bottom: 15px;

            .liBoxHead {
              height: 40px;
              overflow: hidden;

              .box {
                height: 100%;
                border-right: 1px solid #000;
                float: left;
              }

              .box:last-child {
                border-right: none;
              }
            }

            .liBoxConts {
              .liBoxCont {
                overflow: hidden;
                border-top: 1px solid #000;
                display: flex;

                .box {
                  border-right: 1px solid #000;

                  .img {
                    padding: 15px;
                  }
                }

                .box:last-child {
                  border-right: none;
                }
              }
            }
          }
        }
      }
    }

    .cont:hover {
      background-color: rgba(239, 248, 255, 0.5);
    }
  }
}

.dis-cent {
  display: flex;
  align-items: center;
  justify-content: center;
}

.w130 {
  width: 130px;
}

.w90 {
  width: 90px;
}

.w50 {
  width: 50px;
}

.w10 {
  width: 10vw;
}

.w15 {
  width: 15vw;
}

.w20 {
  width: 20vw;
}
</style>
